import axios from "axios";
import {
  generateUUID,
  generateNonce,
  generatePasswordDigest,
} from "../../utils/generateSessionIDs";
import { v4 as uuidv4 } from "uuid";

const API_URL = process.env.REACT_APP_API_BASE_URL;

async function searchFlight(
  sessionId: string,
  corporationCode: string,
  airlineCode: string
): Promise<any> {
  const soapResult = await callAmadeusSOAPAPI(
    sessionId,
    corporationCode,
    airlineCode
  );

  return soapResult;
}

async function callAmadeusSOAPAPI(
  sessionId: string,
  corporationCode: string,
  airlineCode: string
): Promise<any> {
  try {
    const response = await axios.post(`${API_URL}/negotiate-price`, {
      sessionId: sessionId,
      corporationCode: corporationCode,
      airlineCode: airlineCode,
    });
    return response.data;
  } catch (error) {
    console.error("Error making SOAP request:", error);
    throw new Error("SOAP request failed");
  }
}

const saveCorporationCodeOnDB = async (
  corporationCode: string,
  airlineCode: string
) => {
  try {
    const response = await axios.post(
      `${API_URL}/negotiate-price/save-corporation-code`,
      {
        corporationCode: corporationCode,
        airlineCode: airlineCode,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error saving corporation code on:", error);
  }
};

const getAllCorporationCodes = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/negotiate-price/all-corporation-code`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching corporation codes:", error);
  }
};

export { searchFlight, saveCorporationCodeOnDB, getAllCorporationCodes };
